import { useMemo } from 'react';
import { useAppSelector } from '../../core/utils';
import { selectCurrentVehicle } from '../../core/reducers/currentVehicle';
import constructFromTemplate from './constructFromTemplate';
const setSearchParams = (url, params) => {
    try {
        const targetUrl = new URL(url);
        params.forEach(param => targetUrl.searchParams.set(param.key, param.value));
        return targetUrl.toString();
    }
    catch (error) {
        return '';
    }
};
const useInventoryLeadUrl = (hrefTemplate, dealerCode) => {
    const { modelYear, modelKey, trimKey, transmissionKey, exteriorColorKey, interiorColorKey } = useAppSelector(selectCurrentVehicle);
    return useMemo(() => {
        if (!hrefTemplate || !dealerCode) {
            return '';
        }
        // Construct the URL
        const constructedUrl = constructFromTemplate(hrefTemplate, { modelYear, modelKey, dealerCode });
        const params = [
            { key: 'trim', value: trimKey },
            { key: 'transmission', value: transmissionKey },
            { key: 'exteriorColor', value: exteriorColorKey },
            { key: 'interiorColor', value: interiorColorKey },
        ];
        return setSearchParams(constructedUrl, params);
    }, [hrefTemplate, dealerCode, modelKey, modelYear, trimKey, transmissionKey, exteriorColorKey, interiorColorKey]);
};
export default useInventoryLeadUrl;
